// extracted by mini-css-extract-plugin
module.exports = {"tooltip_wrapper":"styles_tooltip_wrapper__l5nRE","img_button_active":"styles_img_button_active__1xt9J","img_button_desactive":"styles_img_button_desactive__18ZK8"};